import { DifficultyId } from '../constants';

export interface DifficultySpec {
  readonly id: DifficultyId;
  readonly name: 'CALM' | 'BRIGHT' | 'FRACTURE';
  readonly projectileSpeed: number;
  readonly telegraphScale: number;
  readonly spawnDensity: number;
  readonly luxScale: number;
  readonly priceScale: number;
  readonly continueLives: number;
  readonly derivedAttackChance: number;
}

export const DIFFICULTIES: readonly DifficultySpec[] = Object.freeze([
  Object.freeze({ id: DifficultyId.Calm, name: 'CALM', projectileSpeed: 0.78, telegraphScale: 1.35, spawnDensity: 0.78, luxScale: 1.3, priceScale: 0.85, continueLives: 4, derivedAttackChance: 0 }),
  Object.freeze({ id: DifficultyId.Bright, name: 'BRIGHT', projectileSpeed: 1, telegraphScale: 1, spawnDensity: 1, luxScale: 1, priceScale: 1, continueLives: 3, derivedAttackChance: 0.25 }),
  Object.freeze({ id: DifficultyId.Fracture, name: 'FRACTURE', projectileSpeed: 1.25, telegraphScale: 0.72, spawnDensity: 1.28, luxScale: 0.86, priceScale: 1.18, continueLives: 2, derivedAttackChance: 0.65 }),
]);

export function getDifficulty(id: DifficultyId): DifficultySpec {
  return DIFFICULTIES[id] ?? DIFFICULTIES[DifficultyId.Bright]!;
}
